import SkeletonBase from "./SkeletonBase"

/**
 * Skeleton pour la section de progression dans le profil
 * Inclut les stats et la liste de cours
 */
export default function ProfileProgressSkeleton() {
  return (
    <div className="space-y-6">
      {/* Learning Stats skeleton */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <SkeletonBase 
          className="h-6 w-48 mb-4" 
          width="12rem"
          height="1.5rem"
        />
        <div className="grid grid-cols-3 gap-6">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="text-center">
              <SkeletonBase 
                className="h-8 w-12 mx-auto mb-2" 
                width="3rem"
                height="2rem"
              />
              <SkeletonBase 
                className="h-4 w-24 mx-auto" 
                width="6rem"
                height="1rem"
              />
            </div>
          ))}
        </div>
      </div>

      {/* My Courses Section skeleton */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <SkeletonBase 
          className="h-6 w-32 mb-6" 
          width="8rem"
          height="1.5rem"
        />
        
        {/* Course list skeleton */}
        <div className="space-y-4">
          {[...Array(3)].map((_, i) => (
            <div 
              key={i}
              className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg"
            >
              {/* Course image skeleton */}
              <SkeletonBase 
                className="w-24 h-16 flex-shrink-0" 
                width="6rem"
                height="4rem"
                rounded="rounded-md"
              />
              
              {/* Course info skeleton */}
              <div className="flex-1 space-y-2">
                <SkeletonBase 
                  className="h-5 w-3/4" 
                  width="75%"
                  height="1.25rem"
                />
                <SkeletonBase 
                  className="h-4 w-1/2" 
                  width="50%"
                  height="1rem"
                />
                
                {/* Progress bar skeleton */}
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <SkeletonBase 
                    className="h-2 rounded-full" 
                    width="60%"
                    height="0.5rem"
                    rounded="rounded-full"
                  />
                </div>
                
                {/* Progress text skeleton */}
                <SkeletonBase 
                  className="h-3 w-24" 
                  width="6rem"
                  height="0.75rem"
                />
              </div>

              {/* Button skeleton */}
              <SkeletonBase 
                className="w-24 h-10" 
                width="6rem"
                height="2.5rem"
                rounded="rounded-md"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
